import { canRead } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

import { RESOURCE_NAME } from './consts';

export const canReadUserStatistics = authorizeIf(canRead(RESOURCE_NAME));
